(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bigens-subscription-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const ATC_TEXT_DEFAULT = 'Adicionar ao carrinho';
    const ATC_TEXT_SUBSCRIBE = 'Assinar agora';

    // Seletores
    // O card de assinatura é identificado pela presença do subtítulo
    // ".kaching-bundles__subscriptions__subtitle", que não existe no card de compra avulsa.
    const SUB_BAR_SELECTOR =
      '.kaching-bundles__subscriptions .kaching-bundles__bar:has(.kaching-bundles__subscriptions__subtitle)';
    const ATC_BUTTON_SELECTOR = 'add-to-cart-component button[type="submit"]';
    const ATC_TEXT_SELECTOR = '.add-to-cart-text__content span span';

    const modal = document.getElementById('bigens-subscription-modal');
    if (!modal) return;

    let lastFocusedElement = null;
    let pendingButton = null;

    // ---------- Modal open/close ----------
    function openModal(triggerButton) {
      lastFocusedElement = triggerButton;
      pendingButton = triggerButton;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Foco no botão primário
      requestAnimationFrame(() => {
        const primaryBtn = modal.querySelector('[data-confirm]');
        if (primaryBtn) primaryBtn.focus();
      });

      document.addEventListener('keydown', handleKeydown);
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeydown);

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }

      pendingButton = null;
    }

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
        return;
      }

      // Focus trap básico
      if (e.key === 'Tab') {
        const focusable = modal.querySelectorAll(
          'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    // ---------- Modal listeners ----------
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]')) {
        closeModal();
      } else if (e.target.closest('[data-confirm]')) {
        // Confirma: submete o form diretamente, sem re-disparar o evento de click.
        // Usar btn.click() faria o handler de capture rodar de novo e poderia reabrir o modal
        // por conflito com o sistema on:click declarativo do Horizon.
        if (pendingButton) {
          const btn = pendingButton;
          const form = btn.closest('form');
          closeModal();

          requestAnimationFrame(() => {
            if (form && typeof form.requestSubmit === 'function') {
              // requestSubmit dispara o evento 'submit' no form com o botão como submitter,
              // que é o que o Horizon escuta via on:submit="/handleSubmit"
              form.requestSubmit(btn);
            } else {
              // Fallback para navegadores sem requestSubmit
              btn.dataset.bigensSubConfirmed = 'true';
              btn.click();
            }
          });
        }
      }
    });

    // ---------- Detecção de assinatura ativa ----------
    // Suporta duas versões do Kaching:
    // - Versão antiga: role="checkbox" + aria-checked="true"
    // - Versão nova: role="button" + class="kaching-bundles__bar--selected"
    function isSubscriptionActive() {
      const subBar = document.querySelector(SUB_BAR_SELECTOR);
      if (!subBar) return false;

      if (subBar.getAttribute('aria-checked') === 'true') return true;
      if (subBar.classList.contains('kaching-bundles__bar--selected')) return true;

      return false;
    }

    function updateButtonLabel() {
      // Estratégia: toggle de classe no <add-to-cart-component>.
      // O CSS sobrescreve o texto via pseudo-elemento, imune a re-renders do Horizon.
      const components = document.querySelectorAll('add-to-cart-component');
      const active = isSubscriptionActive();

      components.forEach((comp) => {
        comp.classList.toggle('is-subscription-active', active);
      });
    }

    // ---------- Intercept ATC click ----------
    function handleAtcClick(e) {
      const btn = e.currentTarget;

      // Se já foi confirmado pelo modal, deixa passar
      if (btn.dataset.bigensSubConfirmed === 'true') {
        delete btn.dataset.bigensSubConfirmed;
        return;
      }

      // Se não tem assinatura ativa, deixa passar
      if (!isSubscriptionActive()) return;

      // Intercepta e abre modal
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openModal(btn);
    }

    function attachAtcListener() {
      const btn = document.querySelector(ATC_BUTTON_SELECTOR);
      if (!btn || btn.dataset.bigensSubBound === 'true') return;
      btn.dataset.bigensSubBound = 'true';
      // capture: true para rodar antes do listener interno do Shopify/Kaching
      btn.addEventListener('click', handleAtcClick, { capture: true });
    }

    // ---------- Observer para mudanças no Kaching ----------
    function initObserver() {
      const target = document.querySelector('.kaching-bundles__subscriptions');
      if (!target) return false;

      const observer = new MutationObserver(() => {
        updateButtonLabel();
        attachAtcListener();
      });

      // Escuta os dois sinais usados pelo Kaching para marcar assinatura ativa:
      // aria-checked (versão antiga) e class (versão nova)
      observer.observe(target, {
        attributes: true,
        attributeFilter: ['aria-checked', 'class'],
        subtree: true,
      });

      return true;
    }

    // ---------- Boot ----------
    function boot() {
      attachAtcListener();
      updateButtonLabel();
      const ok = initObserver();

      // Se Kaching ainda não renderizou, tenta de novo
      if (!ok) {
        const retry = new MutationObserver(() => {
          if (document.querySelector('.kaching-bundles__subscriptions')) {
            initObserver();
            updateButtonLabel();
            attachAtcListener();
            retry.disconnect();
          }
        });
        retry.observe(document.body, { childList: true, subtree: true });

        // Timeout de segurança: para de observar após 10s
        setTimeout(() => retry.disconnect(), 10000);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
